(function() {
  var section = document.querySelector('.bike-selector');
  if (!section) return;

  var dataEl = section.querySelector('[data-bikes-data]');
  if (!dataEl) return;

  var bikesData = JSON.parse(dataEl.textContent);
  var brandSelect = section.querySelector('[data-brand-select]');
  var modelSelect = section.querySelector('[data-model-select]');
  var findBtn = section.querySelector('[data-find-btn]');
  var quickBtns = section.querySelectorAll('[data-quick-brand]');
  var selectedLink = '';

  function updateModels(brandKey) {
    if (!brandKey || !bikesData[brandKey]) {
      modelSelect.innerHTML = '<option value="">First select a brand...</option>';
      modelSelect.disabled = true;
      findBtn.disabled = true;
      selectedLink = '';
      return;
    }

    var brand = bikesData[brandKey];
    var html = '<option value="">Choose a model...</option>';

    if (brand.models && brand.models.length > 0) {
      brand.models.forEach(function(model) {
        html += '<option value="' + model.link + '">' + model.name + '</option>';
      });
    }

    modelSelect.innerHTML = html;
    modelSelect.disabled = false;
    selectedLink = brand.default_link || '';
    findBtn.disabled = false;
  }

  // Find brand key by name (case-insensitive)
  function findBrandKeyByName(name) {
    var lowerName = name.toLowerCase().trim();
    // First try to find by option data-brand-name attribute
    var options = brandSelect.querySelectorAll('option[data-brand-name]');
    for (var i = 0; i < options.length; i++) {
      if (options[i].dataset.brandName.toLowerCase().trim() === lowerName) {
        return options[i].value;
      }
    }
    // Fallback: try handleized version
    var handleized = name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    if (bikesData[handleized]) {
      return handleized;
    }
    return null;
  }

  brandSelect.addEventListener('change', function() {
    updateModels(this.value);
  });

  modelSelect.addEventListener('change', function() {
    if (this.value) {
      selectedLink = this.value;
    } else if (brandSelect.value && bikesData[brandSelect.value]) {
      selectedLink = bikesData[brandSelect.value].default_link || '';
    }
  });

  findBtn.addEventListener('click', function() {
    if (selectedLink && selectedLink !== '#') {
      window.location.href = selectedLink;
    }
  });

  // Quick brand buttons - select by brand name
  quickBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var brandName = btn.dataset.quickBrand;
      var brandKey = findBrandKeyByName(brandName);
      if (brandKey) {
        brandSelect.value = brandKey;
        updateModels(brandKey);
      }
    });
  });
})();
